import { Dropdown, PageModel, ResourceEdit, TextField, Typography } from "@cakemail-org/ui-components-v2"
import { useTranslation } from "react-i18next"
import { Box, SelectChangeEvent, Stack } from "@mui/material"
import { ChangeEvent, MouseEvent, MouseEventHandler, useState } from "react"
import { TPageSocialShareEdit } from "./types"
import "./styles.scss"
import { setDataInPath } from "../../../../utils/data"
import { TDropMenuItemClick } from "@cakemail-org/ui-components-v2/dist/esm/components/dropMenu/types"
import { TFileManagerFile } from "../../../../components/beeEditor/types"
import { getImageInfo } from "../../../../utils/images"

export function PageSocialShareEdit({ page, savePage, setPage, toggleFileManager, fileManagerActionRef }: TPageSocialShareEdit) {
    const seoData = page?.seo || {}

    const { t } = useTranslation()

    function handleSeoFieldChangeTimeout(event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
        const { name, value } = event.target

        const dataToUpdate = setDataInPath({ name, value, data: page.seo, merge: true })

        savePage({
            dataToUpdate,
            render: false
        })
    }

    function handleOgImageChange(event: SelectChangeEvent<string>) {
        const { name, value } = event.target
        if (value === "upload") {
            return
        }

        const dataToUpdate = setDataInPath({ name, value, data: page.seo, merge: true })

        savePage({ dataToUpdate })
    }

    function handleFileInsert(file: TFileManagerFile) {
        fileManagerActionRef.current = undefined
        toggleFileManager(false)
        //setFaviconError("")

        getImageInfo(file["public-url"]).then((imageInfo) => {
            // Image dimensions are valid, save the favicon
            const dataToUpdate = setDataInPath({
                name: "seo.og_image",
                value: file["public-url"],
                data: page.seo
            })

            setPage(new PageModel({ ...page, ...dataToUpdate }))
            savePage({
                dataToUpdate
            })
        }).catch((error) => {
            //setFaviconError(t("pages-details-favicon-load-error"))
        })
    }

    function handleOgImageUpload() {
        fileManagerActionRef.current = handleFileInsert
        toggleFileManager()
    }
    const hasSocialShareData = seoData.og_title || seoData.og_description || seoData.og_image
    const support = hasSocialShareData && <Stack className="social-share-preview">
        <Box className="social-share-preview-image">
            <img src={seoData.og_image || page.thumbnail_url?.replace("/194/130/", "/1200/630/")} />
        </Box>
        <Typography variant="body2" color="body1.main" className="social-share-preview-title">
            {seoData.title}
        </Typography>
        <Typography variant="body1" className="social-share-preview-description">
            {seoData.description}
        </Typography>
        <Typography variant="body1" color="body2.main" className="social-share-preview-url">
            {page.published_url}
        </Typography>
    </ Stack>

    const ogImage = seoData.og_image && seoData.og_image.split("/").pop()

    return (
        <ResourceEdit
            className="pageSocialShareEditResource"
            editable
            status={
                hasSocialShareData ? "valid" : "empty"
            }
            title={t("pages-details-social-share-title")}
            desc={t("pages-details-social-share-desc")}
            support={support}
            editableContent={<Stack gap={6}>
                <Stack gap={6}>
                    <TextField
                        name="seo.og_title"
                        label={t("pages-details-social-share-og-title-title")}
                        placeholder={t("pages-details-social-share-og-title-placeholder")}
                        defaultValue={seoData.og_title || ""}
                        timeout={{
                            callback: handleSeoFieldChangeTimeout
                        }}
                    />
                    <TextField
                        name="seo.og_description"
                        label={t("pages-details-social-share-og-description-title")}
                        placeholder={t("pages-details-social-share-og-description-placeholder")}
                        defaultValue={seoData.og_description || ""}
                        multiline
                        rows={3}
                        timeout={{
                            callback: handleSeoFieldChangeTimeout
                        }}
                    />

                    <Dropdown
                        name="seo.og_image"
                        label={t("pages-details-social-share-og-image-title")}
                        value={ogImage || "empty"}
                        options={[
                            ...(ogImage ? [{ text: ogImage, value: ogImage }] : []),
                            { text: t("pages-details-social-share-og-image-generated"), value: "empty" },
                            { text: t("general-upload-image"), value: "upload", onClick: handleOgImageUpload, isAction: true }
                        ]}
                        onChange={handleOgImageChange}
                    />
                </Stack>
                {support}
            </Stack>
            }
        />
    )
}

